import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { FiHash, FiInbox } from 'react-icons/fi';
import TarjetaPerfil, { Skeleton, Vacio } from './TarjetaPerfil';

const ESTADOS = [
  { clave: 'abierto', label: 'Abiertos' },
  { clave: 'retenido', label: 'Retenidos' },
  { clave: 'cerrado', label: 'Cerrados' },
];

const ETIQUETAS_ESTADO = {
  abierto: 'Abierto',
  retenido: 'Retenido',
  cerrado: 'Cerrado',
};

/** Tickets del usuario: primero el reparto por estado, luego los últimos cinco. */
const TarjetaTickets = ({ tickets, cargando, onVerTodos }) => {
  const conteo = useMemo(() => tickets.reduce((acc, t) => {
    acc[t.estado_del_ticket] = (acc[t.estado_del_ticket] || 0) + 1;
    return acc;
  }, {}), [tickets]);

  return (
    <TarjetaPerfil
      icono={FiHash}
      titulo="Tickets del usuario"
      extra={!cargando && tickets.length > 0 && (
        <span className="perfil-card-contador">{tickets.length}</span>
      )}
    >
      {cargando ? (
        <Skeleton filas={4} />
      ) : tickets.length === 0 ? (
        <Vacio icono={FiInbox}>Este usuario no ha creado tickets.</Vacio>
      ) : (
        <>
          <div className="perfil-tickets-resumen">
            {ESTADOS.map(({ clave, label }) => (
              <div key={clave} className={`perfil-ticket-stat perfil-ticket-stat--${clave}`}>
                <span className="perfil-ticket-stat-valor">{conteo[clave] || 0}</span>
                <span className="perfil-ticket-stat-label">{label}</span>
              </div>
            ))}
          </div>

          <div className="mini-tickets-usuario">
            {tickets.slice(0, 5).map((t) => (
              <Link key={t.identificador} to={`/ticket/${t.identificador}`} className="mini-ticket-item">
                <span className="mini-ticket-asunto">{t.asunto}</span>
                {/* Con un estado desconocido la pastilla salía vacía: se cae al
                    propio valor para que siempre diga algo. */}
                <span className={`mini-ticket-estado ${t.estado_del_ticket || ''}`}>
                  {ETIQUETAS_ESTADO[t.estado_del_ticket] || t.estado_del_ticket || 'Sin estado'}
                </span>
              </Link>
            ))}
          </div>

          <button type="button" className="mini-tickets-ver-todos" onClick={onVerTodos}>
            Ver los {tickets.length} tickets en el panel →
          </button>
        </>
      )}
    </TarjetaPerfil>
  );
};

export default TarjetaTickets;
